import { useRouter } from 'next/router';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';
import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import { ShareButton } from 'src/components/search/_ShareButton/ShareButton';

import styles from './ShareContentButton.module.css';

type ShareContentButtonProps = ComponentProps & {
	fields: {
		ShareButtonText?: Field<string>;
		ShareButtonToolTip: Field<string>;
		ShareOptions: SocialSharingOptions;
		NoShareOptions: Field<string>;
		Title: string;
		Tags: ExtendedItem &
			[
				{
					fields: {
						Title: Field<string>;
					};
				}
			];
	};
};

export default function ShareContentButton(props: ShareContentButtonProps): JSX.Element {
	const router = useRouter();

	return (
		<div className={`${styles.shareContentButton} maxWidth pad`}>
			<ShareButton
				shareButtonText={props.fields.ShareButtonText}
				shareButtonToolTip={props.fields.ShareButtonToolTip}
				shareOptions={props.fields.ShareOptions}
				noShareOptions={props.fields.NoShareOptions}
				shareTitle={props.fields.Title}
				shareUrl={process.env.PUBLIC_URL + router.asPath}
				topicsPageShare
			/>
		</div>
	);
}
